import React from 'react';

interface SupabaseConfigNoticeProps {
  message?: string;
}

const SupabaseConfigNotice: React.FC<SupabaseConfigNoticeProps> = ({ message }) => {
  return (
    <div className="bg-amber-500/10 border border-amber-500/20 text-amber-200 text-sm p-4 rounded-xl" data-testid="supabase-config-notice">
      <div className="font-bold">Supabase setup required</div>
      <div className="mt-1 text-amber-200/90">
        {message || 'Please confirm your Supabase Auth settings (Email provider + Redirect URLs) and try again.'}
      </div>
      <div className="mt-3 text-xs text-amber-200/80 space-y-1">
        <div><span className="font-semibold">Site URL:</span> http://localhost:3000</div>
        <div><span className="font-semibold">Redirect URL allowlist:</span> http://localhost:3000/*</div>
        <div><span className="font-semibold">Auth:</span> Enable Email provider + Email confirmations</div>
      </div>
    </div>
  );
};

export default SupabaseConfigNotice;
